import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AccesosEmails } from 'src/common/acceso';
import { Observable } from 'rxjs';


@Injectable()
export class EmailService {

    private readonly ACCESO_BASE_URL: string = environment.backendUrl + '/email';
	private readonly FIND_EMAILS: string = this.ACCESO_BASE_URL;
	private readonly ACCCESO_FAV: string = this.ACCESO_BASE_URL + '/favorito';
	private readonly ACCESO: string = environment.emailAccesoUrl + '/email/acceso';

	private readonly ID_EMAIL_MF: string = "idEmailMf";

    constructor( private http: HttpClient ) {
    }

	findEmails(): Observable<AccesosEmails> {
		return this.http.get<AccesosEmails>( this.FIND_EMAILS );
	}

	addEmailFavorito( idEmailMf: number, emailAbreviado: string ): Observable<Object> {
		return this.http.post<Object>( this.ACCCESO_FAV, { idEmailMf, emailAbreviado } );
	}

	removeEmailFavorito( idEmailMf: number ): Observable<Object> {
		let params: HttpParams = new HttpParams().set( this.ID_EMAIL_MF, idEmailMf.toString() );
		return this.http.delete( this.ACCCESO_FAV, { params } );
	}

	getEmailAcceso( emailCompleto: string ): Observable<void> {
		return this.http.post<void>( this.ACCESO, { email: emailCompleto } );
	}

}